import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type FormFieldGenerationParams } from '../../__base/generation';

export function generateImageFormField(
  params: FormFieldGenerationParams<'image'>,
): PartialPropsOf<'image'> {
  let props: PartialPropsOf<'image'> = applyPropsPatch(params.props, {
    content: {
      title: { enabled: true },
      imageSource: { enabled: false },
      options: {
        behavior: 'contain',
        unlimitedUpload: params.inputData.column.multipleValues,
      },
    },
    style: { image: { offset: { margin: '$t.spacingFormField' } } },
  });

  if (params.inputData.readonly) {
    props = applyPropsPatch(props, { content: { options: { readonly: true } } });
  }

  return props;
}
